@let regionValue = region();
@let cellTrackingSupportedValue = cellTrackingSupported();
@let isArchiveModeValue = isArchiveMode();
@let settingsValue = settings();
@let seasonStartedValue = seasonStarted();
@let isMobilePlatformValue = isMobilePlatform();

<mat-drawer-container autosize>
  <!-- Settings -->
  <mat-drawer #drawer mode="over" position="end">
    <button mat-icon-button class="close-button" (click)="drawer.toggle()">
      <fa-icon [icon]="['far', 'times']"></fa-icon>
    </button>
    <ng-container *ngTemplateOutlet="radarSettings"></ng-container>
  </mat-drawer>

  <div class="base-container">
    @if (seasonStartedValue) {
      <div class="flex-flow-wrapper">
        <ng-container *ngTemplateOutlet="cardMap"></ng-container>
        <ng-container *ngTemplateOutlet="cardInfoBox"></ng-container>
      </div>
    }
  </div>

  <ng-template #cardMap>
    <mat-card
      appearance="outlined"
      class="map-card"
      [class.archive-mode-active]="isArchiveMode()">
      <!-- Der blinkende Indikator-Punkt am Rand der Karte -->
      @if (isArchiveMode()) {
        <div class="archive-live-dot" [matTooltip]="'Archiv-Modus aktiv'">
          <span class="dot-core"></span>
          <span class="dot-pulse"></span>
          <span class="dot-text">Archive-Mode</span>
        </div>
      }
      <mat-card-header>
        <fa-icon
          mat-card-avatar
          [icon]="['far', 'umbrella']"
          size="2x"></fa-icon>
        @if (mapDtg.isValid()) {
          <mat-card-title>
            @if (isMobilePlatformValue) {
              {{ mapDtg | datex: 'dd DD.MM.YYYY HH:mm' }}
            } @else {
              {{ mapDtg | datex: 'dddd DD.MM.YYYY HH:mm' }}
              -
              {{
                (isForecast
                  ? 'PRODUCT.RADAR.PrecTypeForecast'
                  : isArchive
                    ? 'PRODUCT.RADAR.Archive'
                    : 'PRODUCT.RADAR.PrecType'
                ) | translate
              }}
            }
          </mat-card-title>
        }
        <mat-card-subtitle>
          {{ 'PRODUCT.RADAR.TITLE' | translate }}
          {{
            (regionValue
              ? 'PRODUCT.RADAR.REGIONS.' + regionValue
              : 'CUSTOMER.COUNTRY.LOADING'
            ) | translate
          }}
        </mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        @if (isMobilePlatformValue) {
          <div class="mobile-radar-toolbar">
            <button
              mat-stroked-button
              class="mobile-radar-toolbar-button"
              [class.active]="showMobileRegionPanel()"
              [matTooltip]="'PRODUCT.RADAR.REGIONS.SELECT' | translate"
              (click)="showMobileRegionPanel.set(!showMobileRegionPanel())">
              <fa-icon [icon]="['far', 'location-dot']"></fa-icon>
            </button>
            <button
              mat-stroked-button
              class="mobile-radar-toolbar-button"
              [class.active]="isArchiveModeValue"
              [disabled]="isProductDeactive()"
              [matTooltip]="'PRODUCT.RADAR.Archive' | translate"
              (click)="onToggleArchiveMobile()">
              <fa-icon [icon]="['far', 'calendar-days']"></fa-icon>
            </button>
            <button
              mat-stroked-button
              class="mobile-radar-toolbar-button"
              [class.active]="showMobileLegend()"
              matTooltip="Legende"
              (click)="showMobileLegend.set(!showMobileLegend())">
              <fa-icon [icon]="['far', 'list']"></fa-icon>
            </button>
            <button
              mat-stroked-button
              class="mobile-radar-toolbar-button"
              [matTooltip]="'HOME.SETTINGS' | translate"
              (click)="drawer.toggle()">
              <fa-icon [icon]="['far', 'cogs']"></fa-icon>
            </button>
          </div>

          @if (showMobileRegionPanel()) {
            <div class="mobile-radar-panel">
              <form>
                @let regionsValue = regions();
                @if (regionsValue.length > 1) {
                  <mat-form-field appearance="fill" class="region-select">
                    <mat-label>{{
                      'PRODUCT.RADAR.REGIONS.SELECT' | translate
                    }}</mat-label>
                    <mat-select
                      [formControl]="regionControl"
                      placeholder="{{
                        'PRODUCT.RADAR.REGIONS.SELECT' | translate
                      }}"
                      (selectionChange)="
                        onRegionSelectionChange($event.value)
                      ">
                      @for (radarRegion of regionsValue; track $index) {
                        <mat-option [value]="radarRegion">
                          {{
                            'PRODUCT.RADAR.REGIONS.' + radarRegion | translate
                          }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                }
                <mat-form-field appearance="fill" class="city-select">
                  <mat-label>{{ 'PRODUCT.RADAR.ZOOM' | translate }}</mat-label>
                  <mat-select
                    [formControl]="zoomPointControl"
                    [compareWith]="compareZoomPoints"
                    placeholder="{{ 'PRODUCT.RADAR.ZOOM' | translate }}"
                    (selectionChange)="onCitySelectionChange($event.value)">
                    @for (
                      zoomPoint of centerCitiesOfRegion();
                      track $index
                    ) {
                      <mat-option [value]="zoomPoint">
                        {{
                          zoomPoint['searchName'] === 'whole Area'
                            ? ('PRODUCT.RADAR.REGIONCENTER.' + regionValue
                              | translate)
                            : zoomPoint['searchName']
                        }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </form>
            </div>
          }

          @if (isArchiveModeValue && allowedDates().length > 0) {
            <div class="mobile-radar-panel">
              <form>
                <mat-form-field
                  appearance="fill"
                  (click)="mobilePicker.open()"
                  class="date-select">
                  <mat-label>{{
                    'PRODUCT.RADAR.DATESELECT' | translate
                  }}</mat-label>
                  <input
                    matInput
                    [formControl]="dateControl"
                    [matDatepicker]="mobilePicker"
                    [matDatepickerFilter]="dateFilter"
                    (dateChange)="onDateChange($event)" />
                  <mat-datepicker-toggle matIconSuffix [for]="mobilePicker">
                    <fa-icon
                      matDatepickerToggleIcon
                      [icon]="['far', 'calendar-alt']"
                      transform="up-2 shrink-4"
                      size="lg"></fa-icon>
                  </mat-datepicker-toggle>
                  <mat-datepicker #mobilePicker></mat-datepicker>
                </mat-form-field>
              </form>
            </div>
          }
        }

        @if (!isMobilePlatformValue || isArchiveModeValue) {
          <div class="slider-bar">
            <div class="controls">
              @let isPauseValue = isPause();
              @if (isPauseValue) {
                <button mat-icon-button class="control" (click)="onPlay()">
                  <fa-icon [icon]="['far', 'play']" size="lg"></fa-icon>
                </button>
              } @else {
                <button mat-icon-button class="control" (click)="onPause()">
                  <fa-icon [icon]="['far', 'pause']" size="lg"></fa-icon>
                </button>
              }
            </div>
            <div class="slider">
              @let sliderOptionsValue = sliderOptions();
              @if (!isArchiveModeValue && sliderOptionsValue) {
                <ngx-slider
                  [(value)]="sliderDate"
                  [options]="sliderOptionsValue"
                  (userChange)="onSliderChange($event)">
                </ngx-slider>
              }
              @let sliderArchiveOptionsValue = sliderArchiveOptions();
              @if (isArchiveModeValue && sliderArchiveOptionsValue) {
                <ngx-slider
                  [(value)]="sliderDate"
                  [options]="sliderArchiveOptionsValue"
                  (userChange)="onSliderChange($event)">
                </ngx-slider>
              }
            </div>
          </div>
          <!-- <hr class="radar-map-card__seperator"> -->
          <mat-divider></mat-divider>

          <app-map
            [region]="regionValue"
            [zoomPoint]="centerCity"
            [showCellTracking]="
              !isArchiveModeValue && settingsValue.showCellTracking
            "
            [dtgs]="dtgs()"
            [dtgIndex]="dtgIndex()"
            [loadingData]="loadingImages()"
            [mapType]="mapType.RADAR"
            [radarCirclesPaint]="radarCirclesPaintEnabled$ | async"
            (mapLoad)="onMapLoad($event)"
            class="map"></app-map>
        } @else {
          <app-dashboard-radar
            [settings]="{ region: regionValue, zoomPoint: centerCity }"
            [radarDtg]="mapDtg"
            class="map map--compact"></app-dashboard-radar>
        }
      </mat-card-content>
    </mat-card>
  </ng-template>
  <ng-template #cardInfoBox>
    <div class="radar-info-card">
      @if (!isMobilePlatformValue) {
        <mat-card appearance="outlined">
        <mat-card-header class="radar-legend-block">
          <fa-icon
            mat-card-avatar
            [icon]="['far', 'umbrella']"
            size="2x"></fa-icon>
          <mat-card-title>
            {{ 'PRODUCT.RADAR.TITLE' | translate }}
          </mat-card-title>
          <mat-card-subtitle>{{
            'PRODUCT.RADAR.SUBTITLE' + (isArchiveModeValue ? '_ARCHIVE' : '')
              | translate
          }}</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <form>
            @let regionsValue = regions();
            @if (regionsValue.length > 1) {
              <!-- Region Select -->
              <mat-form-field appearance="fill" class="region-select">
                <mat-label>{{
                  'PRODUCT.RADAR.REGIONS.SELECT' | translate
                }}</mat-label>
                <mat-select
                  [formControl]="regionControl"
                  placeholder="{{ 'PRODUCT.RADAR.REGIONS.SELECT' | translate }}"
                  (selectionChange)="onRegionSelectionChange($event.value)">
                  @for (radarRegion of regionsValue; track $index) {
                    <mat-option [value]="radarRegion">
                      {{ 'PRODUCT.RADAR.REGIONS.' + radarRegion | translate }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <br />
            } @else {
              <!-- <div class="panel__text" *ngIf="region">{{ 'PRODUCT.RADAR.REGIONS.' + region | translate }}</div> -->
            }
            <!-- Zoompoint Select -->
            <mat-form-field appearance="fill" class="city-select">
              <mat-label>{{ 'PRODUCT.RADAR.ZOOM' | translate }}</mat-label>
              <mat-select
                [formControl]="zoomPointControl"
                [compareWith]="compareZoomPoints"
                placeholder="{{ 'PRODUCT.RADAR.ZOOM' | translate }}"
                (selectionChange)="onCitySelectionChange($event.value)">
                @for (zoomPoint of centerCitiesOfRegion(); track $index) {
                  <mat-option [value]="zoomPoint">
                    {{
                      zoomPoint['searchName'] === 'whole Area'
                        ? ('PRODUCT.RADAR.REGIONCENTER.' + regionValue
                          | translate)
                        : zoomPoint['searchName']
                    }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <br />

            <mat-slide-toggle
              color="primary"
              class="custom-color-switch"
              [checked]="isArchiveModeValue"
              [disabled]="isProductDeactive()"
              (change)="onSetShowArchive($event)">
              <span>{{ 'PRODUCT.RADAR.Archive' | translate }}</span>
            </mat-slide-toggle>
            <br />

            @if (allowedDates().length > 0) {
              <!-- Calendar -->
              <mat-form-field
                appearance="fill"
                (click)="picker.open()"
                class="date-select"
                [ngStyle]="{
                  display: isArchiveModeValue ? 'unset' : 'none',
                }">
                <mat-label>{{
                  'PRODUCT.RADAR.DATESELECT' | translate
                }}</mat-label>
                <input
                  matInput
                  [formControl]="dateControl"
                  [matDatepicker]="picker"
                  [matDatepickerFilter]="dateFilter"
                  (dateChange)="onDateChange($event)" />
                <mat-datepicker-toggle matIconSuffix [for]="picker">
                  <fa-icon
                    matDatepickerToggleIcon
                    [icon]="['far', 'calendar-alt']"
                    transform="up-2 shrink-4"
                    size="lg"></fa-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <mat-error>{{ dateControl.errors | json }}</mat-error>
              </mat-form-field>
            }
          </form>
        </mat-card-content>
        </mat-card>
        <br />
      }
      @if (!isMobilePlatformValue || showMobileLegend()) {
      <mat-card appearance="outlined">
        @let intervalValue = interval();
        @if (!settingsValue.showRadarFcst || isArchiveModeValue) {
          <div class="radar-legend-block">
            <p>
              {{
                'PRODUCT.RADAR.description.contentOne'
                  | translate
                    : {
                        timerange: settingsValue.timerange,
                        interval: intervalValue,
                      }
              }}
            </p>
          </div>
        }
        @if (settingsValue.showRadarFcst && !isArchiveModeValue) {
          <div class="radar-legend-block">
            <p>
              {{
                'PRODUCT.RADAR.description.contentOneFcst'
                  | translate
                    : {
                        timerange: settingsValue.timerange,
                        interval: intervalValue,
                      }
              }}
            </p>
            <p>{{ 'PRODUCT.RADAR.description.forecast' | translate }}</p>
          </div>
        }
        <div class="radar-legend-block">
          <p>{{ 'PRODUCT.RADAR.description.contentTwo' | translate }}</p>
          <app-radar-legend
            [legendType]="
              'radar-' + (seasonDate() | getSeason)
            "></app-radar-legend>
        </div>
        @if (
          settingsValue.showCellTracking &&
          !isArchiveModeValue &&
          cellTrackingSupportedValue
        ) {
          <div class="radar-legend-block">
            <h4>
              {{ 'PRODUCT.RADAR.LEGEND.TRACKING.TITLE' | translate }}
            </h4>
            <p>{{ 'PRODUCT.RADAR.LEGEND.TRACKING.TEXT' | translate }}</p>
            <app-radar-legend [legendType]="'celltracking'"> </app-radar-legend>
          </div>
        }
      </mat-card>
      }
    </div>
  </ng-template>

  @if (seasonStartedValue) {
    <div class="basic-margin-wrapper">
      <a id="start"></a>
      @let serverErrorValue = serverError();
      @if (!serverErrorValue) {
      } @else {
        <mat-card appearance="outlined">
          <fa-icon [icon]="['far', 'exclamation-triangle']" size="lg"></fa-icon>
          &nbsp; Der Server antwortet nicht. Bitte versuchen Sie es später noch
          einmal.
        </mat-card>
      }
    </div>
  } @else {
    <div class="basic-margin-wrapper">
      <mat-card appearance="outlined">
        {{ 'PRODUCT.RADAR.SEASON_NOT_STARTED' | translate }}
      </mat-card>
    </div>
  }

  @if (seasonStartedValue) {
    <!-- SIDENAV SETTINGS -->
    <div class="settings-button-stack">
      <!--settings button-->
      <button
        mat-mini-fab
        class="settings-button"
        (click)="drawer.toggle()"
        tp="{{ 'HOME.SETTINGS' | translate }}"
        variation="popper"
        trigger="mouseenter"
        tpPlacement="left">
        <fa-icon [icon]="['far', 'cogs']" size="lg"></fa-icon>
      </button>
    </div>
  }
</mat-drawer-container>

<!-- Settings -->
<ng-template #radarSettings>
  <div class="custom-sidenav-panel">
    <!-- Einheitlicher Sidenav-Titel -->
    <h3 class="sidenav-header-title">
      <fa-icon [icon]="['far', 'cogs']" size="lg"></fa-icon> &nbsp;
      {{ 'HOME.SETTINGS' | translate }}
    </h3>

    <div class="sidenav-layout-container">
      <!-- Scrollbarer Hauptbereich sorgt für perfektes Verhalten bei kleinen Displays -->
      <div class="sidenav-scroll-content">
        <!-- Sektion: Animations-Geschwindigkeit -->
        <div class="parameter-set-group">
          <h4 class="sidenav-section-title">
            {{ 'PRODUCT.RADAR.SPEED' | translate }}
          </h4>
          <div class="settings-slider">
            <ngx-slider
              [value]="settingsValue.animationSpeed"
              [options]="animationSpeedOptions"
              (userChange)="
                onSettingsChange($event, 'animationSpeed');
                onSpeedSliderChange($event)
              "></ngx-slider>
          </div>
        </div>

        <mat-divider class="sidenav-seperator"></mat-divider>

        @if (!isArchiveModeValue) {
          <!-- Sektion: Zeitraum / Time Range -->
          <div class="parameter-set-group">
            <h4 class="sidenav-section-title">
              {{ 'PRODUCT.RADAR.TIMERANGE' | translate }}
            </h4>
            <p class="mat-body-small text-muted">
              {{
                'PRODUCT.RADAR.TIMERANGE_TEXT'
                  | translate: { timerange: settingsValue.timerange }
              }}
            </p>
            <div class="settings-slider">
              <ngx-slider
                [value]="settingsValue.timerange"
                [options]="timeRangeOptions"
                (userChange)="
                  onSettingsChange($event, 'timerange');
                  onTimeRangeChange($event)
                "></ngx-slider>
            </div>
          </div>

          <mat-divider class="sidenav-seperator"></mat-divider>
        }

        @if (!isArchiveModeValue) {
          <!-- Sektion: Niederschlagsartenvorhersage / Forecast -->
          <div class="parameter-set-group">
            <h4 class="sidenav-section-title">
              {{ 'PRODUCT.RADAR.PrecTypeForecast' | translate }}
            </h4>
            <mat-slide-toggle
              class="celltracking-margin custom-color-switch"
              color="primary"
              [checked]="settingsValue.showRadarFcst"
              (change)="onRadarFcstChange($event)">
              {{ 'PRODUCT.RADAR.PrecTypeForecast' | translate }}
            </mat-slide-toggle>
          </div>

          <mat-divider class="sidenav-seperator"></mat-divider>
        }

        @if (!isArchiveModeValue && cellTrackingSupportedValue) {
          <!-- Sektion: Celltracking -->
          <div class="parameter-set-group">
            <h4 class="sidenav-section-title">
              {{ 'PRODUCT.RADAR.LEGEND.TRACKING.TITLE' | translate }}
            </h4>
            <mat-slide-toggle
              class="celltracking-margin custom-color-switch"
              color="primary"
              [checked]="settingsValue.showCellTracking"
              (change)="onCellTrackingChange($event)">
              {{ 'PRODUCT.RADAR.LEGEND.TRACKING.TITLE' | translate }}
            </mat-slide-toggle>
          </div>
        }
      </div>

      <!-- Fixierter Sidenav-Footer für Aktionen (Zentriert den Reset-Button am Boden) -->
      @if (!isArchiveModeValue && regionValue === 'de') {
        <mat-divider></mat-divider>
        <div class="sidenav-footer-actions">
          <button
            mat-flat-button
            class="btn-app-edit full-width-button"
            (click)="onResetSettings()"
            [matTooltip]="'PRODUCT.RADAR.RESET' | translate">
            <fa-icon [icon]="['far', 'sync']"></fa-icon>
            &nbsp; {{ 'PRODUCT.RADAR.RESET' | translate }}
          </button>
        </div>
      }
    </div>
  </div>
</ng-template>
